import React from "react";
import { Col, Row } from "react-bootstrap";
import Navbar from "../homepage/Navbar";
import {Footer} from "../../shared";
import Cookies from "js-cookie";
import search from "../../assets/image/png/search.svg";
import { Header } from "../../shared";

const OrderDetail = () => {
  const token = Cookies.get("token");

  return (
    <>
      <div className="bg_darkblue">
        <Header />
      </div>
      <div className="bg_lightblue_2">
        <div className="container py-5">
          <Row className="pb-4">
            <Col xs={12} sm={8} lg={3}>
              <div className="bg-white px-4 py-3 order_Detail_shadow">
                <p className="d-flex justify-content-between">
                  <span className="fw-bold">Delivery Address</span>{" "}
                  <span className="color_blue_2">Naseeb Kumar</span>
                </p>
                <p>
                  New Dhurina office (Manawali Road) Dhingsara, Fatehabad
                  District - 125053, Haryana
                </p>
                <p className="mb-0">Phone number 9996077721</p>
              </div>
            </Col>
            <Col sm={12} className="mt-4">
              <div className="d-flex p-sm-4 p-3 justify-content-between align-items-center bg-white flex-wrap order_Detail_shadow">
                <div className="col-lg-5 col-md-12 col-12 d-flex gap-sm-5 gap-3 align-items-sm-center flex-column flex-sm-row">
                  <div className="d-flex align-items-center gap-4 gap-lg-5 ">
                    <div className="custom_border2">
                      <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTsQuQ5qFoqFDChsQrlMszx-4zJ3-jOBzUfMY66HWm_oy-DdpsFfqU66SE55aFWNmx-TlA&usqp=CAU"
                        alt=""
                        width={140}
                        height={140}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 fs_15 fw_400 gap-sm-4 d-flex flex-column">
                    A2212 10T 1400KV Brushless Motor for Drone (Soldered
                    Connector)
                    <div className="fw-semibold">₹1999</div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-12 col-12 mt-4">
                  <div className="d-sm-flex justify-content-between flex-row">
                    <div className="col-sm-5 fs_15 fw_400 d-flex flex-column">
                      <p className="fw-bold mb-1">Tracking Number</p>
                      <p>OD329403786083532100</p>
                      <div className="fw-semibold">&nbsp;</div>
                    </div>
                    <div className="mt-sm-0">
                      <div className="col-sm-7 fs_15 fw_400 d-flex flex-column">
                        <p className="fw-bold mb-1">Order ID</p>
                        <p>OD329403786083532100</p>
                      </div>
                      <button className="btn p-2 px-3 ff_heebo col-4 checkout-btn text-white w-auto fs_13">
                        Download Invoice
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default OrderDetail;
